import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const IMPORT_RECALCULATION_ERRORS_LIST_HELP: HelpContent[] = [
    {
        helpContentId: 'import-recalculation-errors-list.recalculate',
        tooltipText: 'Recalculate the assets for this import file transfer.'
    },
    {
        helpContentId: 'import-recalculation-errors-list.include-acknowledged',
        tooltipText: 'Include errors that have already been acknowledged (either manually or automatically upon a successful recalculation).'
    }
];
